import { find, isEmpty, partition, values } from "lodash";
import React, { useMemo } from "react";
import { RouteComponentProps } from "react-router-dom";
import { useContacts } from "../../../context/contacts";
import { useInstalls } from "../../../context/installs";
import { isActiveInstall } from "../../Workspace/InstallsData/utils";
import LinkedInstallsTable from "../common/LinkedInstallsTable";

const ContactInstallsTab: React.FC<RouteComponentProps<{ id: string }>> = (
  props
) => {
  const { contacts, currentContact } = useContacts();
  const { installs } = useInstalls();

  const contact = useMemo(
    () =>
      currentContact ||
      (props.match.params.id ? contacts[props.match.params.id] : undefined),
    [contacts, currentContact, props.match.params.id]
  );

  const [currentlyInstalled, notCurrentlyInstalled] = useMemo(
    () =>
      partition(
        values(installs).filter(
          ({ commissions, location_uuid }) =>
            contact?.linked_location_ids.includes(location_uuid) ||
            !!find(commissions, { contact_uuid: props.match.params.id })
        ),
        isActiveInstall
      ),
    [installs, contact?.linked_location_ids, props.match.params.id]
  );

  const futureInstalls = useMemo(
    () =>
      values(installs).filter(
        ({ location_uuid, installed_at }) =>
          contact?.linked_location_ids.includes(location_uuid) && !installed_at
      ),
    [contact?.linked_location_ids, installs]
  );

  if (!contact) return null;

  return (
    <div className="mt-6 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="w-full mb-6 align-middle inline-block">
        <div className="border-b border-gray-200 dark:border-gray-500 pb-5 mb-5">
          <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">
            Current installs
          </h3>
        </div>
        {!isEmpty(currentlyInstalled) ? (
          <LinkedInstallsTable installs={currentlyInstalled} />
        ) : (
          <p className="text-sm text-gray-500 dark:text-gray-300">
            There are no active installs associated with this contact.
          </p>
        )}
      </div>

      <div className="w-full mb-6 align-middle inline-block">
        <div className="border-b border-gray-200 dark:border-gray-500 pb-5 mb-5">
          <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">
            Past installs
          </h3>
        </div>
        {!isEmpty(notCurrentlyInstalled) ? (
          <LinkedInstallsTable installs={notCurrentlyInstalled} />
        ) : (
          <p className="text-sm text-gray-500 dark:text-gray-300">
            There are no past installs associated with this contact.
          </p>
        )}
      </div>

      <div className="w-full mb-6 align-middle inline-block">
        <div className="border-b border-gray-200 dark:border-gray-500 pb-5 mb-5">
          <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">
            Future installs
          </h3>
        </div>
        {!isEmpty(futureInstalls) ? (
          <LinkedInstallsTable installs={futureInstalls} />
        ) : (
          <p className="text-sm text-gray-500 dark:text-gray-300">
            There are no future installs associated with this contact.
          </p>
        )}
      </div>
    </div>
  );
};

export default ContactInstallsTab;
